import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResultsEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 131,
	height: 108,
	viewBox: "0 0 131 108",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.55396 49.4482V50.5577",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.0603 50.0488L2.96692 50.9821",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 52.5337H2.28195",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.95654 55.0622L2.86316 54.1289",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.55396 55.3658V54.2563",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.403 54.6259L5.66333 53.8862",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.88245 52.7769H6.77295",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.14274 50.188L6.40308 50.9277",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.0969 1V1.73967",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.8779 3.21924H62.6176",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.0969 5.43791V4.69824",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.9462 3.21924H65.2065",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1963 32.0659V33.1754",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8679 35.3945H18.9774",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1963 38.3532V37.2437",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1552 35.3945H23.0457",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.801 72.3926C101.685 72.3926 102.401 73.1096 102.401 73.9936C102.401 74.878 101.685 75.5947 100.801 75.5947C99.917 75.5947 99.2002 74.878 99.2002 73.9936",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M108.125 57.8671C109.076 57.5706 110.533 56.4083 110.87 55.1577C111.176 56.2632 112.458 57.5706 113.614 57.6695C112.312 58.1306 111.067 59.5002 110.87 60.5761C110.736 59.4794 109.014 58.0269 108.125 57.8671Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.5676 71.899C11.043 71.7507 11.7711 71.1697 11.9397 70.5444C12.0926 71.0969 12.7334 71.7507 13.3117 71.8003C12.6609 72.0305 12.0386 72.7155 11.9397 73.2535C11.8725 72.7051 11.0116 71.9787 10.5676 71.899Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.389 20.4524C19.389 21.1383 18.8333 21.6939 18.1479 21.6939C17.4622 21.6939 16.9067 21.1383 16.9067 20.4524C16.9067 19.7668 17.4622 19.2109 18.1479 19.2109C18.8333 19.2109 19.389 19.7668 19.389 20.4524Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M102.266 23.7859C102.266 24.9319 101.337 25.8609 100.191 25.8609C99.0454 25.8609 98.1167 24.9319 98.1167 23.7859C98.1167 22.6399 99.0454 21.7109 100.191 21.7109C101.337 21.7109 102.266 22.6399 102.266 23.7859Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M131 18.164C131 19.0732 130.263 19.81 129.355 19.81C128.446 19.81 127.709 19.0732 127.709 18.164C127.709 17.2548 128.446 16.5181 129.355 16.5181C130.263 16.5181 131 17.2548 131 18.164Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M42.5839 95.0367C42.5839 95.6098 42.1196 96.0743 41.5466 96.0743C40.9739 96.0743 40.5095 95.6098 40.5095 95.0367C40.5095 94.4635 40.9739 93.999 41.5466 93.999C42.1196 93.999 42.5839 94.4635 42.5839 95.0367Z",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.9662 12.4768C41.9662 13.1627 41.4104 13.7183 40.725 13.7183C40.0396 13.7183 39.4839 13.1627 39.4839 12.4768C39.4839 11.7912 40.0396 11.2354 40.725 11.2354C41.4104 11.2354 41.9662 11.7912 41.9662 12.4768Z",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M73.627 106.527C72.8339 106.829 71.9463 106.43 71.6446 105.637C71.3428 104.844 71.7409 103.956 72.5344 103.654C73.3271 103.352 74.2147 103.751 74.5165 104.544C74.8185 105.337 74.4201 106.225 73.627 106.527Z",
			stroke: "#8FC6FF",
			strokeWidth: 1.74503,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M73.1575 77.1854H42.8295C40.6948 77.1854 38.9475 75.4329 38.9475 73.2911V30.0418C38.9475 27.9 40.6948 26.1484 42.8295 26.1484H73.1575C75.293 26.1484 77.0403 27.9 77.0403 30.0418V73.2911C77.0403 75.4329 75.293 77.1854 73.1575 77.1854Z",
			fill: "#7ABCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M70.5686 79.0345H40.2406C38.106 79.0345 36.3586 77.282 36.3586 75.1402V31.891C36.3586 29.7492 38.106 27.9976 40.2406 27.9976H70.5686C72.7041 27.9976 74.4514 29.7492 74.4514 31.891V75.1402C74.4514 77.282 72.7041 79.0345 70.5686 79.0345Z",
			fill: "#A5D0F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M68.0505 80.4941H37.6597C35.5207 80.4941 33.7698 78.7488 33.7698 76.6159V33.5457C33.7698 31.4128 35.5207 29.6685 37.6597 29.6685H68.0505C70.1904 29.6685 71.9413 31.4128 71.9413 33.5457V76.6159C71.9413 78.7488 70.1904 80.4941 68.0505 80.4941Z",
			fill: "#9ACCFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M68.0505 80.4941H37.6597C35.5207 80.4941 33.7698 78.7488 33.7698 76.6159V33.5457C33.7698 31.4128 35.5207 29.6685 37.6597 29.6685H68.0505C70.1904 29.6685 71.9413 31.4128 71.9413 33.5457V76.6159C71.9413 78.7488 70.1904 80.4941 68.0505 80.4941Z",
			fill: "#DAEDFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.6699 42.7908H41.2227C40.5816 42.7908 40.0569 42.2916 40.0569 41.6817C40.0569 41.071 40.5816 40.5718 41.2227 40.5718H63.6699C64.3109 40.5718 64.8357 41.071 64.8357 41.6817C64.8357 42.2916 64.3109 42.7908 63.6699 42.7908Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.6699 49.448H41.2227C40.5816 49.448 40.0569 48.9488 40.0569 48.3389C40.0569 47.7282 40.5816 47.229 41.2227 47.229H63.6699C64.3109 47.229 64.8357 47.7282 64.8357 48.3389C64.8357 48.9488 64.3109 49.448 63.6699 49.448Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.6699 56.1047H41.2227C40.5816 56.1047 40.0569 55.6055 40.0569 54.9957C40.0569 54.3858 40.5816 53.8857 41.2227 53.8857H63.6699C64.3109 53.8857 64.8357 54.3858 64.8357 54.9957C64.8357 55.6055 64.3109 56.1047 63.6699 56.1047Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M63.6699 62.762H41.2227C40.5816 62.762 40.0569 62.2628 40.0569 61.6529C40.0569 61.0422 40.5816 60.543 41.2227 60.543H63.6699C64.3109 60.543 64.8357 61.0422 64.8357 61.6529C64.8357 62.2628 64.3109 62.762 63.6699 62.762Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.9398 69.4187H41.2277C40.5839 69.4187 40.0569 68.9195 40.0569 68.3096C40.0569 67.6989 40.5839 67.1997 41.2277 67.1997H52.9398C53.5836 67.1997 54.1105 67.6989 54.1105 68.3096C54.1105 68.9195 53.5836 69.4187 52.9398 69.4187Z",
			fill: "#89C3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M76.5771 60.8153C72.0886 65.3031 65.1397 65.8093 60.095 62.3444C59.4502 61.8937 58.8366 61.3874 58.2643 60.8153C57.9697 60.5217 57.6921 60.2187 57.4304 59.8996C56.9071 59.2626 56.4488 58.5831 56.0732 57.8811C55.4116 56.6954 54.9617 55.4373 54.716 54.1368C53.9235 50.0583 55.1085 45.6684 58.2643 42.5141C61.4277 39.3503 65.8183 38.1731 69.8975 38.9579C71.1973 39.211 72.4566 39.6609 73.6425 40.3149C74.3456 40.6988 75.0157 41.1571 75.6538 41.6803C75.9719 41.941 76.275 42.2195 76.5687 42.5141C77.1418 43.0862 77.6557 43.6988 78.0981 44.3444C81.5645 49.3874 81.0572 56.336 76.5771 60.8153Z",
			fill: "white",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M75.3181 59.9313C70.6484 64.6019 63.0807 64.601 58.4101 59.9313C53.7456 55.2668 53.7456 47.6982 58.4162 43.0285C63.0807 38.364 70.6484 38.364 75.3129 43.0285C79.9826 47.6982 79.9826 55.2668 75.3181 59.9313ZM77.7161 40.6293C71.7221 34.6353 62.009 34.6353 56.015 40.6293C50.0219 46.6224 50.0167 56.3416 56.0098 62.3356C61.4651 67.7892 70.0155 68.281 76.0295 63.8033C76.6169 63.3653 77.1826 62.8744 77.7222 62.3356C78.261 61.796 78.7519 61.2303 79.189 60.6429C83.6667 54.6281 83.1705 46.0837 77.7161 40.6293Z",
			fill: "#69B0F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M101.307 84.9302L101.055 85.1818C99.3904 86.8475 96.6642 86.8475 94.9985 85.1818L79.6265 69.8098L85.9348 63.5015L101.307 78.8735C102.973 80.5392 102.973 83.2645 101.307 84.9302Z",
			fill: "url(#paint0_linear_2657_14378)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M79.5218 60.1729L84.0643 64.7153L80.8395 67.9393L76.2979 63.3968C76.8973 62.95 77.4736 62.449 78.0251 61.8992C78.5749 61.3495 79.0758 60.7723 79.5218 60.1729Z",
			fill: "#69B0F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M101.077 78.6845L94.8084 84.9518L93.6799 83.8225L99.9473 77.5552L101.077 78.6845Z",
			fill: "#3699FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.2834 63.7184L79.8435 70.1584L78.8867 69.2017L85.3266 62.7617L86.2834 63.7184Z",
			fill: "url(#paint1_linear_2657_14378)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M72.2298 41.4221L56.4367 57.2145C55.8419 56.1485 55.4375 55.0174 55.2175 53.8482L68.8634 40.2021C70.0318 40.4306 71.1638 40.8341 72.2298 41.4221Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M77.4073 45.1754L60.3332 61.2822C59.7217 60.8796 59.1397 60.4266 58.597 59.9146C58.3176 59.651 58.0534 59.3807 57.8062 59.0952L75.0883 42.7905C75.3909 43.0246 75.6783 43.2739 75.9568 43.5375C76.4995 44.0495 76.9878 44.5977 77.4073 45.1754Z",
			fill: "white",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8724 51.5L72.7131 47.6593C72.8954 47.4773 72.9979 47.2304 72.9982 46.9728C72.9984 46.7153 72.8963 46.4682 72.7143 46.2859C72.5324 46.1036 72.2855 46.0011 72.0279 46.0009C71.7704 46.0006 71.5233 46.1027 71.341 46.2847L67.5002 50.1254L63.6595 46.2847C63.4772 46.1024 63.23 46 62.9722 46C62.7144 46 62.4672 46.1024 62.2849 46.2847C62.1026 46.467 62.0002 46.7142 62.0002 46.972C62.0002 47.2298 62.1026 47.477 62.2849 47.6593L66.1257 51.5L62.2849 55.3407C62.1026 55.523 62.0002 55.7702 62.0002 56.028C62.0002 56.2858 62.1026 56.533 62.2849 56.7153C62.4672 56.8976 62.7144 57 62.9722 57C63.23 57 63.4772 56.8976 63.6595 56.7153L67.5002 52.8746L71.341 56.7153C71.5233 56.8976 71.7705 57 72.0283 57C72.2861 57 72.5333 56.8976 72.7156 56.7153C72.8978 56.533 73.0002 56.2858 73.0002 56.028C73.0002 55.7702 72.8978 55.523 72.7156 55.3407L68.8724 51.5Z",
			fill: "#56A3F1"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2657_14378",
			x1: 91.0913,
			y1: 52.0366,
			x2: 68.1616,
			y2: 74.9663,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#B2DAFF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#3699FF"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_2657_14378",
			x1: 82.585,
			y1: 59.0634,
			x2: 75.1884,
			y2: 66.46,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1770CC" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6FB6FF"
			})]
		})] })
	]
});
export default SvgResultsEmptyState;
